export default from './NonAuthLayout';



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/index.js